import React, { forwardRef } from 'react';
import classNames from 'classnames';

const base =
  'inline-block cursor-pointer select-none border text-center align-middle font-normal leading-normal no-underline transition-colors duration-150 ease-in-out focus:outline-none disabled:pointer-events-none disabled:opacity-65';

const sizeClass = {
  sm: 'rounded px-2 py-1 text-sm',
  md: 'rounded px-5 py-2.5 text-base',
  lg: 'rounded px-4 py-2 text-xl',
};

const variantClass = {
  primary:
    'border-primary bg-primary text-white hover:border-primary-hover hover:bg-primary-hover',
  secondary:
    'border-secondary bg-secondary text-white hover:border-primary-hover hover:bg-primary-hover',
  'outline-secondary':
    'border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-white',
  'outline-destructive':
    'border-secondary bg-transparent text-secondary hover:border-danger hover:bg-danger hover:text-white',
  'outline-gray':
    'border-gray-500 bg-transparent text-gray-700 hover:bg-gray-200',
  'outline-opaque-secondary':
    'border-secondary bg-white/70 text-secondary hover:bg-secondary hover:text-white',
  link:
    'border-transparent bg-transparent text-info hover:underline hover:text-[color-mix(in_oklab,var(--color-info),black_15%)]',
  control:
    'border-transparent bg-transparent text-gray-600 hover:bg-gray-300 focus:bg-gray-300 active:bg-gray-300',
};

export const Button = forwardRef(function Button(
  {
    variant = 'primary',
    size = 'md',
    block = false,
    inline = false,
    as,
    tag,
    className,
    type,
    children,
    ...rest
  },
  ref
) {
  const Tag = as || tag || 'button';
  return (
    <Tag
      ref={ref}
      type={Tag === 'button' ? type || 'button' : type}
      {...rest}
      className={classNames(
        base,
        inline ? 'p-0 leading-[inherit] align-baseline' : sizeClass[size] || sizeClass.md,
        variantClass[variant] || variantClass.primary,
        block && 'block w-full',
        className
      )}
    >
      {children}
    </Tag>
  );
});

export default Button;
